<template>
  <div class="cookie-bar">
    <a
      class="cookie-bar__content"
      :href="`/cookie/${lang}.html`"
      target="_blank"
      rel="noopener noreferrer"
      v-html="$translate('cookies')"
    />
    <a
      class="cookie-bar__content"
      :href="`https://www.gucci.com/documents/legal/privacy/${lang}.pdf`"
      target="_blank"
      rel="noopener noreferrer"
      v-html="$translate('privacy')"
    />
  </div>
</template>

<script>
import { getLang } from '@/scripts/utils';

export default {
  name: 'CookieBar',

  data() {
    return {
      lang: getLang(),
    };
  },
};
</script>

<style lang="scss" scoped>
.cookie-bar {
  position: fixed;
  bottom: 25px;
  left: 0;
  width: 100%;

  color: inherit;
  text-align: center;
  color: $color-yellow;
  font-size: 12px;

  pointer-events: none;

  @include mq(ipadP) {
    font-size: 14px;
  }

  &__content {
    pointer-events: auto;
  }
}
</style>
